import { useEffect, useState } from 'react';

const DESKTOP_WIDTH = 1280;
const mediaQuery = `(min-width: ${DESKTOP_WIDTH}px)`;

export function useIsDesktopView(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia(mediaQuery).matches);

  useEffect(() => {
    const media = window.matchMedia(mediaQuery);
    const handler = () => setIsDesktop(media.matches);

    media.addEventListener('change', handler); // modern browsers
    return () => media.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}
